import * as React from 'react'

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button
} from '@mui/material'

import { useDispatch, useSelector } from 'react-redux';
import { pink } from '@mui/material/colors';

import { CSideButton } from '../../components/common/Button';
import { CTableHCell, CTableCell } from '../../components/common/Table';

import { savePermission, changePermission, getPermission } from '../../slices/permission';

function Permission() {
  const [active, setActive] = React.useState('SUPER_ADMIN');
  const permission = useSelector(state => state.permission.permission);
  const dispatch = useDispatch();

  React.useEffect(() => {
    let formData = new FormData();
    formData.append('role', active);
    dispatch(getPermission(formData));
  }, [])

  const handleChange = (module, action) => {
    dispatch(changePermission({module, kind: action}))
  }

  const handleChangeRole = (role) => {
    if(active === role) return;
    setActive(role);
    
    let formData = new FormData();
    formData.append('role', role);
    dispatch(getPermission(formData));
  }

  const handleSave = () => {    
    let jsonData = JSON.stringify(permission);
    let formData = new FormData();
    formData.append('role', active);
    formData.append('permission', jsonData);

    dispatch(savePermission(formData))
      .unwrap()
      .then(success => success ? window.alert("Permission save successfully.") : window.alert("Failed to save permissions."))
      .catch(err => console.log(err));
  }

  return (
    <Box className='w-full flex flex-column flex-basis flex-gap' >
      <Box sx={{paddingTop: 2, paddingLeft: 2}}>
        <Typography 
          sx={{ 
            fontSize: 24, 
            fontWeight: 600, 
            color: '#4A85F6'
          }}
        >
          Permission
        </Typography>
      </Box>
      <Box className='flex-basis'>
        <Paper className='w-full h-full flex flex-row' sx={{borderRadius: 4, margin: 1}}>
          <Box className='h-full' sx={{width: 320, borderRight: '1px solid #F5F5F5'}}>
            <Typography 
              sx={{ 
                fontSize: 16, 
                fontWeight: 400, 
                padding: 2,
              }}
            >
              Roles
            </Typography>
            <Box sx={{padding: 3}}>
              <CSideButton 
                sx={
                  active==='SUPER_ADMIN' ? 
                    { background: '#7354EF', color: 'white' }
                    : 
                    { background: 'white', color: 'rgba(0,0,0,0.7)'}
                  }
                onClick={() => handleChangeRole('SUPER_ADMIN')}
              >
                Super Admin
              </CSideButton>
              <CSideButton 
                sx={
                  active==='ADMIN' ? 
                    { background: '#7354EF', color: 'white' }
                    : 
                    { background: 'white', color: 'rgba(0,0,0,0.7)'}
                  }
                  onClick={() => handleChangeRole('ADMIN')}
                >
                Admin
              </CSideButton>
              <CSideButton 
                sx={
                  active==='USER' ? 
                    { background: '#7354EF', color: 'white' }
                    : 
                    { background: 'white', color: 'rgba(0,0,0,0.7)'}
                  }
                onClick={() => handleChangeRole('USER')}
              >
                User
              </CSideButton>
            </Box>
          </Box>
          <Box className='flex-basis'>
            <Box className='w-full flex flex-row'>
              <Typography 
                sx={{ 
                  fontSize: 16, 
                  fontWeight: 400, 
                  padding: 2,
                }}
                className='flex-basis'
              >
                Manage Permission
              </Typography>
              <Button 
                variant='contained' 
                sx={{ 
                  margin: 2, 
                  color: 'white', 
                  background: '#7354EF'
                }}
                onClick={handleSave}
              >
                Save
              </Button>
            </Box>
            <Box sx={{padding: 3}}>
             <TableContainer className='w-full'>
              <Table  className='w-full' sx={{ minWidth: 650}} size="small" aria-label="a dense table">
                <TableHead sx={{ height: 64}} className='bg-thead color-cell'>
                  <TableRow>
                    <CTableHCell>Module Name</CTableHCell>
                    <CTableHCell>Read</CTableHCell>
                    <CTableHCell>Write</CTableHCell>
                    <CTableHCell>Delete</CTableHCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {permission.map((row, index) => (
                    <TableRow
                      key={index}
                    >
                      <CTableCell component="th" scope="row">
                        {row.module}
                      </CTableCell>
                      <CTableCell>
                        <Checkbox checked={row.read} onClick={() => handleChange(row.module, 'read')} />
                      </CTableCell>
                      <CTableCell>
                        <Checkbox checked={row.write} color='success' onClick={() => handleChange(row.module, 'write')} />
                      </CTableCell>
                      <CTableCell>
                        <Checkbox 
                          checked={row.delete}
                          onClick={() => handleChange(row.module, 'delete')}
                          sx={{
                            color: pink[800],
                            '&.Mui-checked': {
                              color: pink[600],
                            },
                          }} 
                        />
                      </CTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default Permission;